<template>
  <div class="result-card" :class="{'result-card--visible-details': isVisibleDetails}">
    <div class="result-card__description">
      <template v-if="isDiscount">
        <div class="result-card__description-row">
          <div class="result-card__description-label">
            Стоимость<br> со скидкой {{ discountPercent }}%*:
          </div>

          <div class="result-card__description-value" v-html="allInsuranceCostWithDiscount" />
        </div>

        <div class="result-card__description-text">
          Скидка предоставляется только при оформлении на сайте.
        </div>
      </template>

      <template v-else>
        <div class="result-card__description-row">
          <div class="result-card__description-label">
            Стоимость полиса:
          </div>

          <div class="result-card__description-value" v-html="allInsuranceCost" />
        </div>
      </template>
    </div>

    <div class="result-card__content">
      <div class="result-card__info result-card__info--strong">
        <div class="result-card__info-label">
          Стоимость страховки:
        </div>

        <div class="result-card__info-value" v-html="allInsuranceCost" />
      </div>

      <div class="result-card__info">
        <div class="result-card__info-label">
          Страховая сумма:
        </div>

        <div class="result-card__info-value">
          {{ balanceSum }}
        </div>
      </div>

      <div class="result-card__info">
        <div class="result-card__info-label">
          Выгодоприобретатель:
        </div>

        <div class="result-card__info-value">
          {{ prepareData.bankName }}
        </div>
      </div>

<!--      <ElInput-->
<!--        class="result-card__input"-->
<!--        v-model="promotionalCode"-->
<!--        @input="debouncedCouponHandler"-->
<!--        placeholder="Введите промокод"-->
<!--      >-->
<!--      </ElInput>-->

      <hr class="result-card__line">

      <ul class="result-card__links">
        <li class="result-card__links-item">
          <a href="" download="">Частые вопросы</a>
        </li>
        <li class="result-card__links-item">
          <a href="" download>Пример полиса «Имущество»</a>
        </li>
        <li class="result-card__links-item">
          <a href="" download>Пример полиса «Жизнь и здоровье»</a>
        </li>
        <li class="result-card__links-item">
          <a href="" download>Правила ипотечного страхования</a>
        </li>
        <li class="result-card__links-item">
          <a href="" download>Ключевой информационный документ</a>
        </li>
      </ul>
    </div>

    <button class="result-card__toggle-button" @click="toggleClickHandler">
      <span class="result-card__toggle-button-text">
        Свернуть
      </span>

      <SvgIcon class="result-card__toggle-button-icon" name="chevron-down-bondi-blue" />
    </button>
  </div>
</template>

<script>
import {INSURANCE_CARDS} from '@/consts';
import { commafy } from '@/utils/string-helpers';
import InsuranceTariffCard from '@/components/ui/InsuranceTariffCard';
import BaseLink from '@/components/ui/BaseLink';
import TabList from "@/components/shared/tabs/TabList.vue";
import BaseButton from "@/components/ui/BaseButton.vue";
import { debounce } from '@/utils/api-helpers';
import { validateCoupon } from '@/api/routes/calculator-eipoteka';
import SvgIcon from "@/components/ui/SvgIcon.vue";

export default {
  name: 'TheInsuranceVariants',
  components: {
    BaseButton, TabList,
    InsuranceTariffCard,
    BaseLink,
    SvgIcon,
  },
  props: {
    allInsuranceCost: String,
    allInsuranceCostWithDiscount: String,
    prepareData: Object,
  },
  data() {
    return {
      promotionalCode: '',
      discountPercent: 0,
      isVisibleDetails: false,
    };
  },
  computed: {
    cards() {
      return INSURANCE_CARDS
    },
    balanceSum() {
      return this.prepareData ? `${commafy(this.prepareData.balanceSum)} ₽` : ''
    },
    debouncedCouponHandler() {
      const debounceMs = 300;
      return debounce(this.handleCoupon, debounceMs);
    },
    isDiscount() {
      return this.discountPercent > 0;
    }
  },
  methods: {
    async handleCoupon() {
      const couponResp = await validateCoupon(this.promotionalCode);
      this.discountPercent = this.validateCouponResponse(couponResp);

      this.$emit('coupon-discount', {
        promotionalCode: this.promotionalCode,
        discountPercent: this.discountPercent,
      });
    },
    validateCouponResponse(response) {
      return response?.result === true && !!response?.discount
        ? response.discount
        : 0;
    },
    toggleClickHandler() {
      this.isVisibleDetails = !this.isVisibleDetails;
    },
  }
}
</script>

<style scoped lang="scss">
.result-card {
  padding: rem(16);

  border-radius: rem(16);
  background-color: rgba($gallery, 0.5);

  &--visible-details & {
    &__content {
      @media #{$screen-big} {
        display: block;
      }
    }

    &__toggle-button {
      &-icon {
        transform: rotate(180deg);
      }
    }
  }

  &__content {
    display: block;

    @media #{$screen-big} {
      display: none;
    }
  }

  &__info {
    @include text-props(14px, 16.94px);

    display: flex;

    @media #{$screen-very-small} {
      @include text-props(12px, 14.52px);
    }

    &:not(:last-child) {
      margin-bottom: rem(8);
    }

    &--strong {
      font-weight: 600;
    }

    &-label {
      flex-grow: 1;
      padding-right: rem(8);

      @media #{$screen-very-small} {
        @include text-props(11px, 14.52px);
      }
    }

    &-value {
      text-align: right;
    }
  }

  &__description {
    margin: rem(-16px) rem(-16px) rem(16px);
    padding: rem(16);

    border-radius: rem(16) rem(16) 0 0;
    background-color: $swans-down;

    &-row {
      @include text-props(14px, 17px, 600);

      display: flex;

      &:not(:last-child) {
        margin-bottom: rem(8);
      }
    }

    &-label {
      @include text-props(18px, 21.78px, 600);

      flex-grow: 1;

      @media #{$screen-small} {
        @include text-props(16px, 19.36px, 700);
      }

      & br {
        display: none;

        @media #{$screen-small} {
          display: block;
        }
      }
    }

    &-value {
      @include text-props(18px, 21.78px, 700);

      color: $bondi-blue;

      @media #{$screen-small} {
        @include text-props(16px, 19.36px, 700);
      }
    }

    &-text {
      @include text-props(12px, 14.52px, 400);

      width: rem(260px);

      color: $dove-gray;
    }
  }

  &__line {
    height: 0;
    margin: rem(16) 0;

    border: none;
    border-top: rem(1) solid $monte-carlo;
  }

  &__input {
    &:not(:first-child) {
      margin-top: rem(16);
    }
  }

  &__links {
    @include text-props(10px, 13px);

    display: flex;
    flex-wrap: wrap;
    gap: rem(8);
  }

  &__toggle-button {
    display: none;

    padding: 0;

    cursor: pointer;

    color: $bondi-blue;
    border: none;
    background-color: transparent;

    @media #{$screen-big} {
      display: flex;
      align-items: center;
    }

    &:not(:first-child) {
      margin-top: rem(16);
    }

    &-text {
      @include text-props(14px, 17px);

      &:not(:last-child) {
        margin-right: rem(8);
      }
    }

    &-icon {
      transition: 0.2s ease-out;
    }
  }
}
</style>
